import React from 'react'
import { Link } from 'react-router-dom'

const GetStarted = () => {
  return (
    <div className='w-full flex flex-col justify-center items-center p-5 pt-10 pb-10 relative bg-cyan-50'>
        <h1 className='text-2xl sm:text-3xl font-semibold text-cyan-700 uppercase font-overpass text-center'>Let's Get You Some Comfort!</h1>
        <p className='text-[15px] sm:text-lg my-1 text-black/60 text-center font-semibold font-karla'>Check Our Products to Decorate your Floors.</p>
        <Link to='/store'>
          <button className='rounded-full border py-1 px-3 mt-2 font-karla border-cyan-500 text-cyan-500 hover:text-white hover:bg-cyan-500 duration-100'>Store</button>
        </Link>
    </div>
  )
}

export default GetStarted